export default async function createSwipers() {
  let swiperStartEl = document.querySelector('.swiper--start');
  let swiperHistoryEl = document.querySelector('.swiper--history');
  let swiperGalleryEl = document.querySelector('.swiper--gallery');
  let swiperGallerySimpleEl = document.querySelector('.swiper--gallery-simple');

  if (!swiperStartEl && !swiperHistoryEl && !swiperGalleryEl && !swiperGallerySimpleEl) return;

  const [{ Swiper, Navigation, Pagination, Lazy, Autoplay }] = await Promise.all([
    import('swiper'),
  ]);

  if (swiperStartEl) {
    const swiperStart = new Swiper(swiperStartEl, {
      modules: [ Navigation, Lazy, Autoplay ],
      speed: 600,
      slidesPerView: 1,
      // allowTouchMove: false,
      focusableElements: 'a, input, select, option, textarea, button, video, label',
      loop: true,
      navigation: {
        nextEl: '.swiper-nav--start--next',
        prevEl: '.swiper-nav--start--prev',
        disabledClass: 'is-disabled',
      },
      lazy: {
        enabled: true,
        loadOnTransitionStart: true,
        loadPrevNext: false,
      },
      // autoplay: {
      //   delay: 8000,
      //   disableOnInteraction: true,
      //   pauseOnMouseEnter: true,
      // },
      on: {
        init: function () {
          this.el.addEventListener("focusin", (event) => {
            this.slides.forEach((slide, index) => {
              if (! slide.contains(event.target)) return;
this.el.scrollTo(0, 0); // prevent browser overflow behavior from messing swiper elements position
this.slideTo(index);
            });
          });
        },
        slideChange: function() {
          swiperPreventFocus(this.slides, this.activeIndex, this.previousIndex);
        },
      }
    });
    function swiperPreventFocus(slides, currIndex, prevIndex) {
      slides.forEach((slide, index) => {
        let focusableElements = slide.querySelectorAll('a, button');
        if (index == currIndex) {
          focusableElements.forEach(element => {
            element.removeAttribute('tabIndex');
          });
        }
        else {
          focusableElements.forEach(element => {
            element.setAttribute('tabIndex', -1);
          });
        }
      })
    }
  }

  if (swiperHistoryEl) {
    const swiperHistory = new Swiper('.swiper--history', {
      modules: [ Navigation, Pagination, Lazy, Autoplay ],
      speed: 600,
      slidesPerView: 1,
      centeredSlides: true,
      navigation: {
        nextEl: '.swiper-nav--history--next',
        prevEl: '.swiper-nav--history--prev',
        disabledClass: 'is-disabled',
      },
      pagination: {
        el: '.swiper-pagination--history',
        type: 'bullets',
        bulletClass: 'swiper-pagination__bullet',
        bulletActiveClass: 'current',
        clickable: true,
        renderBullet: function(index, className) {
          return `<div class="${className}">${this.slides[index].dataset.label}</div>`;
        },
      },
      lazy: {
        enabled: true,
        checkInView: true,
        loadOnTransitionStart: true,
        loadPrevNext: true,
      },
      autoplay: {
        delay: 8000,
        disableOnInteraction: true,
        pauseOnMouseEnter: true,
      },
      on: {
        init: function() {
          historyDynamicPagination(this.pagination, this.realIndex);

          this.el.addEventListener("focusin", (event) => {
            this.slides.forEach((slide, index) => {
              if (! slide.contains(event.target)) return;
this.el.scrollTo(0, 0); // prevent browser overflow behavior from messing swiper elements position
this.slideTo(index);
            });
          });
        },
        resize: function() {
          historyDynamicPagination(this.pagination, this.realIndex);
        },
        slideChange: function() {
          historyDynamicPagination(this.pagination, this.realIndex);
        },
      }
    });

    function historyDynamicPagination(pagination, activeIndex) {
      let paginationWidth = pagination.el.offsetWidth;
      let bulletWidth = pagination.bullets[0].offsetWidth;
      let marginWidth = parseInt(window.getComputedStyle(pagination.bullets[0])['margin-right']);
      let bulletMarginWidth = bulletWidth + marginWidth;
      let offset = 0;

      if (bulletMarginWidth * activeIndex > paginationWidth / 2) {
        offset = bulletMarginWidth * activeIndex - paginationWidth / 2 + bulletWidth / 2;

        let paginationContentWidth = bulletMarginWidth * pagination.bullets.length - marginWidth;
        if (offset > paginationContentWidth - paginationWidth) {
          offset = paginationContentWidth - paginationWidth;
        }
      }

      pagination.bullets.forEach(bullet => {
        bullet.style['transform'] = `translateX(${offset * -1}px)`;
      });
    }
  }

  if (swiperGalleryEl) {
    const swiperGallery = new Swiper('.swiper--gallery', {
      modules: [ Navigation, Pagination, Lazy, Autoplay ],
      speed: 600,
      allowTouchMove: false,
      slidesPerView: 1,
      spaceBetween: 20,
      navigation: {
        nextEl: '.swiper-nav--next',
        prevEl: '.swiper-nav--prev',
        disabledClass: 'is-disabled',
      },
      pagination: {
        el: '.swiper-pagination--gallery',
        type: 'bullets',
        bulletClass: 'swiper-pagination__bullet',
        bulletActiveClass: 'current',
        clickable: true,
        // dynamicBullets: true,
        // dynamicMainBullets: 1,
        renderBullet: function(index, className) {
          let url = this.slides[index].dataset.url;
          return `<div class="${className}"><img class="${className}__img" src="${url}"/></div>`;
        },
      },
      lazy: {
        enabled: true,
        checkInView: true,
        loadOnTransitionStart: true,
        loadPrevNext: false,
      },
      autoplay: {
        delay: 8000,
        disableOnInteraction: true,
        pauseOnMouseEnter: true,
      },
      on: {
        init: function() {
          dynamicPaginationFix(this.pagination, this.realIndex);

          this.el.addEventListener("focusin", (event) => {
            this.slides.forEach((slide, index) => {
              if (! slide.contains(event.target)) return;
this.el.scrollTo(0, 0); // prevent browser overflow behavior from messing swiper elements position
this.slideTo(index);
            });
          });
        },
        afterInit: function () {
          document.dispatchEvent(new CustomEvent('swiperReady'));
        },
        slideChange: function() {
          dynamicPaginationFix(this.pagination, this.realIndex);
        },
      }
    });

    function dynamicPaginationFix(pagination, activeIndex) {
      const spacing = 10;
      let paginationWidth = pagination.el.offsetWidth;
      let bulletWidth = pagination.bullets[0].offsetWidth;
      let spacedBulletWidth = bulletWidth + spacing;
      let offset = -4; // move 2px right to fit outline with its offset
      // let offset = 0;

      if (spacedBulletWidth * activeIndex > paginationWidth / 2) {
        offset = spacedBulletWidth * activeIndex - paginationWidth / 2 + bulletWidth / 2;

        let paginationContentWidth = spacedBulletWidth * pagination.bullets.length - spacing;
        if (offset > paginationContentWidth - paginationWidth) {
          offset = paginationContentWidth - paginationWidth;
        }
      }

      pagination.bullets.forEach(bullet => {
        bullet.style['transform'] = `translateX(${offset * -1}px)`;
      });
    }
  }

  if (swiperGallerySimpleEl) {
    const simpleGalleryContainers = document.querySelectorAll('.swiper--gallery-simple');
    simpleGalleryContainers.forEach(simpleGalleryContainer => {
      let swiperSimpleGallery = new Swiper(simpleGalleryContainer, {
        modules: [ Navigation, Lazy, Autoplay ],
        speed: 600,
        allowTouchMove: false,
        slidesPerView: 1,
        spaceBetween: 10,
        navigation: {
          nextEl: '.swiper-nav--next',
          prevEl: '.swiper-nav--prev',
          disabledClass: 'is-disabled',
        },
        lazy: {
          enabled: true,
          checkInView: true,
          loadOnTransitionStart: true,
          loadPrevNext: false,
        },
        autoplay: {
          delay: 8000,
          disableOnInteraction: true,
          pauseOnMouseEnter: true,
        },
        breakpoints: {
          640: {
            slidesPerView: 2,
          },
          1280: {
            slidesPerView: 3,
          },
        },
        on: {
          init: function () {
            this.el.addEventListener("focusin", (event) => {
              this.slides.forEach((slide, index) => {
                if (! slide.contains(event.target)) return;
this.el.scrollTo(0, 0); // prevent browser overflow behavior from messing swiper elements position
this.slideTo(index);
              });
            });
          },
        }
      });
    });
  }

}
